import { useEffect } from "react";
import { useNavigate } from "react-router";
import { PageHeader } from "@/components/page-header";
import { Skeleton } from "@/components/ui/skeleton";
import { useAdminAccess } from "@/lib/hooks/use-admin";
import { useT } from "@/lib/i18n/use-t";
import { T } from "./page.i18n";
import { TenantWrapper } from "./tenant-wrapper";

export default function TenantsPage() {
  const navigate = useNavigate();
  const { isLoading, isQuantfolioAdmin: canView } = useAdminAccess();
  const t = useT(T);

  useEffect(() => {
    if (isLoading) return;
    if (!canView) {
      navigate("/", { replace: true });
    }
  }, [isLoading, canView, navigate]);

  if (isLoading || !canView) {
    return (
      <div className="space-y-6">
        <Skeleton className="h-6 w-48" />
        <Skeleton className="h-10 w-64" />
        <Skeleton className="h-64" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <PageHeader
        breadcrumbs={[{ label: t.admin, href: "/admin" }, { label: t.tenants }]}
        title={t.tenants}
        description={t.tenantsDescription}
      />

      <TenantWrapper />
    </div>
  );
}
